import React, { useContext, useState, memo, useEffect, useRef } from 'react';
import { AppStore } from "../App/App.Store";
import "./Popup.scss";
import { Service } from '../App/App.Service';
import { apiURL, Environment, returnURL } from '../Services/Base';

const Popup = () => {
    const formRef = useRef(null);
    const inputRef = useRef(null);

    const {
        popupState,
        setPopup
    } = useContext(AppStore);

    const item = popupState > -1 ? Service.getItems()[popupState] : null;

    useEffect(() => {
        if (popupState < 0) return;
        (() => {
            if (window.document.getElementById("GoogleRecap")) return;

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = "GoogleRecap";
            script.async = 1;
            script.defer = 1;
            script.src = 'https://www.google.com/recaptcha/api.js';

            document.getElementsByTagName('head')[0].appendChild(script);
        })();
    }, [popupState])

    const sendVotes = () => {
        formRef.current.submit();
    }

    window.sendVotes = sendVotes;

    return (
        <section className={`section section-popup ${popupState == -1 ? " thanks " : ""}${popupState > -2 ? "active" : ""}`}>
            <div className="fade" onClick={() => {
                setPopup(-2);
            }}></div>
            {popupState > -2 ?
                <div className="card">
                    <div className="close" onClick={() => {
                        setPopup(-2);
                    }}></div>
                    <div className={`image image-${popupState+1}`}></div>
                    {popupState == -1 ? <div className="container">
                        <div className="title">
                            תודה<br />
                            <span>על השתתפותכם!</span>
                        </div>
                    </div> :
                        <div className="container">
                            <form action={`${apiURL}Handle.ashx`} method="post" name="form1" ref={formRef}>
                                <input type="hidden" name="vote" value="" ref={inputRef} />
                                <input type="hidden" name="callbackurl" value={returnURL} />
                            </form>
                            <div className="title">{item.Product}</div>
                            <div className="teaser">{item.School}</div>
                            <div className="text">
                                {item.Text}
                            </div>
                            <div className="button" onClick={() => {
                                inputRef.current.value = popupState + 1;
                                if (!Environment().isLocalhost) {
                                    window.grecaptcha.execute();
                                } else {
                                    sendVotes();
                                }
                            }}>
                                <div className="button-text">בחר/י</div>
                                <div className="arrow"></div>
                                <div className="g-recaptcha"
                                    data-callback="sendVotes"
                                    data-size="invisible"
                                    data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>
                            </div>
                        </div>}
                </div> : ""}
        </section>)
}

export default memo(Popup);


// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx